/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { VisitLatLngDtoModel, VisitLatLngDtoModelType } from "./VisitLatLngDtoModel"
import { VisitLatLngDtoModelSelector } from "./VisitLatLngDtoModel.base"
import { RootStoreType } from "./index"


/**
 * VisitsGeocodedDtoBase
 * auto generated base class for the model VisitsGeocodedDtoModel.
 */
export const VisitsGeocodedDtoModelBase = ModelBase
  .named('VisitsGeocodedDto')
  .props({
    __typename: types.optional(types.literal("VisitsGeocodedDto"), "VisitsGeocodedDto"),
    visits: types.union(types.undefined, types.array(types.late((): any => VisitLatLngDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class VisitsGeocodedDtoModelSelector extends QueryBuilder {
  visits(builder: string | VisitLatLngDtoModelSelector | ((selector: VisitLatLngDtoModelSelector) => VisitLatLngDtoModelSelector) | undefined) { return this.__child(`visits`, VisitLatLngDtoModelSelector, builder) }
}
export function selectFromVisitsGeocodedDto() {
  return new VisitsGeocodedDtoModelSelector()
}

export const visitsGeocodedDtoModelPrimitives = selectFromVisitsGeocodedDto()
